import _ from 'lodash';

const INITIAL_STATE = {
  List: [],
  FormActive: 'List',
  Selected: {},
  SelectedId: [],
  Count: {},
  DocActivity: [],
  DocActivityCount: {},
  Loading: 'RETRIEVING',
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'ADD_ACTIVITYLOG_DOCUMENT': {
      const { List } = { ...state };
      return {
        ...state,
        List: _.orderBy(
          List.concat(action.activity_log_document),
          ['dateAdded'],
          ['desc']
        ),
      };
    }
    case 'SET_ACTIVITYLOG_LOADING': {
      return { ...state, Loading: action.loading };
    }
    case 'SET_ACTIVITYLOG_DOCUMENT_LIST': {
      return {
        ...state,
        List: _.uniqBy(action.list, 'id'),
        ...(typeof action.count !== 'undefined' ? { Count: action.count } : {}),
        Loading: '',
      };
    }
    case 'SET_ACTIVITYLOG_DOCUMENT': {
      return {
        ...state,
        DocActivity: _.uniqBy(action.list, 'id'),
        ...(typeof action.count !== 'undefined'
          ? { DocActivityCount: action.count }
          : {}),
        Loading: '',
      };
    }
    case 'RESET_ACTIVITYLOG_DOCUMENT': {
      return { ...INITIAL_STATE };
    }
    case 'UPDATE_ACTIVITYLOG_DOCUMENT_LIST': {
      const { List } = { ...state };
      const updatedList = List.concat(action.list);

      return {
        ...state,
        List: updatedList,
        ...(typeof action.count !== 'undefined' ? { Count: action.count } : {}),
      };
    }
    default:
      return state;
  }
}
